import { render, staticRenderFns } from "./staffDetailModal.vue?vue&type=template&id=5f6a720f&scoped=true"
import script from "./staffDetailModal.vue?vue&type=script&lang=js"
export * from "./staffDetailModal.vue?vue&type=script&lang=js"
import style0 from "./staffDetailModal.vue?vue&type=style&index=0&id=5f6a720f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6a720f",
  null
  
)

export default component.exports